import { useEffect } from 'react';
import Cover from 'src/components/Cover';
import Downloads from 'src/components/Downloads';
import CallToAction from 'src/components/CallToAction';
import { FeatureShowcase } from 'src/components/showcase/feature-showcase';
import { Icon, IconSprite } from 'src/components/site/icons';
import { RevealController } from 'src/components/site/reveal-controller';
import { WaveBackground } from 'src/components/site/wave-background';

const VALUES = [
  { icon: 'layers' as const, label: 'Organized by context' },
  { icon: 'nodes' as const, label: 'Connected by tools' },
  { icon: 'target' as const, label: 'Designed for focus' },
];

const Landing = (): JSX.Element => {
  useEffect(() => {
    document.documentElement.classList.add('js');
  }, []);

  return (
    <>
      <IconSprite />
      <WaveBackground />
      <RevealController />
      <main>
        <Cover />
        <section aria-label="WerxPace values" style={{ paddingTop: 0 }}>
          <ul className="vals">
            {VALUES.map((value, index) => {return (
              <li key={value.label} className="rv" style={{ ['--d' as string]: index }}>
                <span className="ring"><Icon name={value.icon} /></span>
                {value.label}
              </li>
            )})}
          </ul>
        </section>
        <section className="feature-section" aria-labelledby="showcase-heading">
          <h2 id="showcase-heading" className="rv">
            Everything <span className="c">in one place.</span>
          </h2>
          <FeatureShowcase />
        </section>
        <Downloads />
        <CallToAction />
      </main>
    </>
  );
};

export default Landing;
